import React from 'react';
import Spinner from '@/presentation/components/Spinner';

import Select from '../../../../reusables/Select';
import { WrapperCardGrid } from '@/presentation/modules/reservations/modules/register/styled';
import CourseResume from './components/courseResume';
import MyCoursesCollapsibles from './components/MyCoursesCollapsibles';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import ModuleContainer from '@/presentation/components/Container';

interface IProps {
  isOnline: any;
  handlePeriod: any;
  handlerBack: any;
  myPeriodCourse: any;
  mySummaryCourse: any;
  isLoadingPeriod: boolean;
  isLoadingSummary: boolean;
  selectPeriod: any;
  subsectionHeader: any;
}

const MyCoursesView: React.FC<IProps> = (props) => {
  const { handlerBack, isLoadingPeriod, isLoadingSummary } = props;
  const { myPeriodCourse, mySummaryCourse, handlePeriod } = props;
  const { selectPeriod, isOnline, subsectionHeader } = props;
  return (
    <ModuleContainer containerType="subsection">
      {!isOnline ? (
        <></>
      ) : (
        <>
          <SubsectionHeader
            title={subsectionHeader[0].title}
            onClick={handlerBack}
          />
          <div>
            <WrapperCardGrid
              style={{
                maxWidth: 360
              }}
            >
              <Select
                returnObject
                items={myPeriodCourse}
                itemName="name"
                itemValue="value"
                value={selectPeriod}
                itemCount={4}
                label={'Periodo:'}
                onChange={handlePeriod}
                isLoading={isLoadingPeriod}
                placeholder={'Selecciona un periodo'}
              />
            </WrapperCardGrid>
            {isLoadingSummary && <Spinner />}
            {!isLoadingSummary && mySummaryCourse && (
              <>
                <CourseResume mySummaryCourse={mySummaryCourse.summary} />
                <MyCoursesCollapsibles
                  data={mySummaryCourse.courses}
                  selectPeriod={selectPeriod.value}
                />
              </>
            )}
          </div>
        </>
      )}
    </ModuleContainer>
  );
};

export default MyCoursesView;
